module.exports = __webpack_public_path__ + "static/media/MurrahDimensions.f2021229.pdf";